// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Additional theme variables and component styles */
:root {
  /* Additional light theme colors - improved contrast */
  --success-color: #2e7d32;
  --warning-color: #ed6c02;
  --error-color: #d32f2f;
  --info-color: #1976d2;
  --token-success-bg: rgba(46, 125, 50, 0.12);
  --token-warning-bg: rgba(237, 108, 2, 0.12);
  --token-error-bg: rgba(211, 47, 47, 0.1);
  --token-error-underline: var(--error-color);
  --card-bg: var(--bg-primary);
  --card-text-color: var(--text-primary);
  --text-container-bg: var(--bg-primary);
  --input-bg: var(--bg-primary);
  --button-hover: #e3f2fd;
  --border-radius: 8px;
  --box-shadow: 0 2px 8px var(--shadow-color);
}

[data-theme='dark'] {
  /* Additional dark theme colors */
  --success-color: #66bb6a;
  --warning-color: #ffb74d;
  --error-color: #ef5350;
  --info-color: #42a5f5;
  --token-success-bg: rgba(102, 187, 106, 0.18);
  --token-warning-bg: rgba(255, 183, 77, 0.18);
  --token-error-bg: rgba(239, 83, 80, 0.18);
  --token-error-underline: var(--error-color);
  --card-bg: var(--bg-secondary);
  --card-text-color: var(--text-primary);
  --text-container-bg: var(--bg-secondary);
  --input-bg: var(--bg-secondary);
  --button-hover: #1e3a5f;
  --border-radius: 8px;
  --box-shadow: 0 2px 8px var(--shadow-color);
}

/* MUI components: ensure text stays readable in dark mode
   (MUI defaults many form controls to dark text even when the background is dark). */

[data-theme='dark'] .MuiInputBase-root,
[data-theme='dark'] .MuiInputBase-input,
[data-theme='dark'] .MuiSelect-select,
[data-theme='dark'] .MuiSelect-icon,
[data-theme='dark'] .MuiSvgIcon-root,
[data-theme='dark'] .MuiInputLabel-root,
[data-theme='dark'] .MuiFormHelperText-root {
  color: var(--text-primary);
}

[data-theme='dark'] .MuiOutlinedInput-notchedOutline {
  border-color: var(--border-color);
}

/* Standard (underline) variant inputs */
[data-theme='dark'] .MuiInput-underline:before {
  border-bottom-color: var(--border-color);
}

[data-theme='dark'] .MuiInput-underline:hover:not(.Mui-disabled):before {
  border-bottom-color: var(--text-secondary);
}

[data-theme='dark'] .MuiInput-underline:after {
  border-bottom-color: var(--accent-color);
}

/* Checkboxes: make outline/check visible in dark mode */
[data-theme='dark'] .MuiCheckbox-root {
  color: var(--text-primary);
}

[data-theme='dark'] .MuiCheckbox-root.Mui-checked {
  color: var(--accent-color);
}

[data-theme='dark'] .MuiPaper-root.MuiMenu-paper,
[data-theme='dark'] .MuiPaper-root.MuiPopover-paper {
  background-color: var(--bg-secondary);
  color: var(--text-primary);
}

[data-theme='dark'] .MuiPaper-root.MuiMenu-paper .MuiMenuItem-root,
[data-theme='dark'] .MuiPaper-root.MuiPopover-paper .MuiMenuItem-root {
  color: var(--text-primary);
}

/* Common component styles */
.card {
  background-color: var(--card-bg);
  border: 1px solid var(--border-color);
  border-radius: var(--border-radius);
  box-shadow: var(--box-shadow);
  transition: all 0.3s ease;
}

.card:hover {
  box-shadow: 0 4px 16px var(--shadow-color);
}

.input-field {
  background-color: var(--input-bg);
  border: 1px solid var(--border-color);
  border-radius: var(--border-radius);
  color: var(--text-primary);
  transition: all 0.3s ease;
}

.input-field:focus {
  border-color: var(--accent-color);
  box-shadow: 0 0 0 2px rgba(97, 218, 251, 0.2);
}

.button {
  background-color: var(--accent-color);
  color: var(--text-primary);
  border: none;
  border-radius: var(--border-radius);
  padding: 8px 16px;
  cursor: pointer;
  transition: all 0.3s ease;
}

.button:hover {
  background-color: var(--button-hover);
  transform: translateY(-1px);
}

/* Status colors */
.status-success {
  color: var(--success-color);
}

.status-warning {
  color: var(--warning-color);
}

.status-error {
  color: var(--error-color);
}

.status-info {
  color: var(--info-color);
}

/* Smooth transitions for all theme changes */
* {
  transition:
    background-color 0.3s ease,
    color 0.3s ease,
    border-color 0.3s ease,
    box-shadow 0.3s ease;
}

/* Scrollbar theming */
::-webkit-scrollbar {
  width: 8px;
}

::-webkit-scrollbar-track {
  background: var(--bg-secondary);
}

::-webkit-scrollbar-thumb {
  background: var(--border-color);
  border-radius: 4px;
}

::-webkit-scrollbar-thumb:hover {
  background: var(--text-secondary);
}
`, "",{"version":3,"sources":["webpack://./src/styles/theme.css"],"names":[],"mappings":"AAAA,oDAAoD;AACpD;EACE,sDAAsD;EACtD,wBAAwB;EACxB,wBAAwB;EACxB,sBAAsB;EACtB,qBAAqB;EACrB,2CAA2C;EAC3C,2CAA2C;EAC3C,wCAAwC;EACxC,2CAA2C;EAC3C,4BAA4B;EAC5B,sCAAsC;EACtC,sCAAsC;EACtC,6BAA6B;EAC7B,uBAAuB;EACvB,oBAAoB;EACpB,2CAA2C;AAC7C;;AAEA;EACE,iCAAiC;EACjC,wBAAwB;EACxB,wBAAwB;EACxB,sBAAsB;EACtB,qBAAqB;EACrB,6CAA6C;EAC7C,4CAA4C;EAC5C,yCAAyC;EACzC,2CAA2C;EAC3C,8BAA8B;EAC9B,sCAAsC;EACtC,wCAAwC;EACxC,+BAA+B;EAC/B,uBAAuB;EACvB,oBAAoB;EACpB,2CAA2C;AAC7C;;AAEA;qFACqF;;AAErF;;;;;;;EAOE,0BAA0B;AAC5B;;AAEA;EACE,iCAAiC;AACnC;;AAEA,wCAAwC;AACxC;EACE,wCAAwC;AAC1C;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,wCAAwC;AAC1C;;AAEA,wDAAwD;AACxD;EACE,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;;EAEE,qCAAqC;EACrC,0BAA0B;AAC5B;;AAEA;;EAEE,0BAA0B;AAC5B;;AAEA,4BAA4B;AAC5B;EACE,gCAAgC;EAChC,qCAAqC;EACrC,mCAAmC;EACnC,6BAA6B;EAC7B,yBAAyB;AAC3B;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,iCAAiC;EACjC,qCAAqC;EACrC,mCAAmC;EACnC,0BAA0B;EAC1B,yBAAyB;AAC3B;;AAEA;EACE,iCAAiC;EACjC,6CAA6C;AAC/C;;AAEA;EACE,qCAAqC;EACrC,0BAA0B;EAC1B,YAAY;EACZ,mCAAmC;EACnC,iBAAiB;EACjB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,qCAAqC;EACrC,2BAA2B;AAC7B;;AAEA,kBAAkB;AAClB;EACE,2BAA2B;AAC7B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA,6CAA6C;AAC7C;EACE;;;;wBAIsB;AACxB;;AAEA,sBAAsB;AACtB;EACE,UAAU;AACZ;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,+BAA+B;EAC/B,kBAAkB;AACpB;;AAEA;EACE,iCAAiC;AACnC","sourcesContent":["/* Additional theme variables and component styles */\n:root {\n  /* Additional light theme colors - improved contrast */\n  --success-color: #2e7d32;\n  --warning-color: #ed6c02;\n  --error-color: #d32f2f;\n  --info-color: #1976d2;\n  --token-success-bg: rgba(46, 125, 50, 0.12);\n  --token-warning-bg: rgba(237, 108, 2, 0.12);\n  --token-error-bg: rgba(211, 47, 47, 0.1);\n  --token-error-underline: var(--error-color);\n  --card-bg: var(--bg-primary);\n  --card-text-color: var(--text-primary);\n  --text-container-bg: var(--bg-primary);\n  --input-bg: var(--bg-primary);\n  --button-hover: #e3f2fd;\n  --border-radius: 8px;\n  --box-shadow: 0 2px 8px var(--shadow-color);\n}\n\n[data-theme='dark'] {\n  /* Additional dark theme colors */\n  --success-color: #66bb6a;\n  --warning-color: #ffb74d;\n  --error-color: #ef5350;\n  --info-color: #42a5f5;\n  --token-success-bg: rgba(102, 187, 106, 0.18);\n  --token-warning-bg: rgba(255, 183, 77, 0.18);\n  --token-error-bg: rgba(239, 83, 80, 0.18);\n  --token-error-underline: var(--error-color);\n  --card-bg: var(--bg-secondary);\n  --card-text-color: var(--text-primary);\n  --text-container-bg: var(--bg-secondary);\n  --input-bg: var(--bg-secondary);\n  --button-hover: #1e3a5f;\n  --border-radius: 8px;\n  --box-shadow: 0 2px 8px var(--shadow-color);\n}\n\n/* MUI components: ensure text stays readable in dark mode\n   (MUI defaults many form controls to dark text even when the background is dark). */\n\n[data-theme='dark'] .MuiInputBase-root,\n[data-theme='dark'] .MuiInputBase-input,\n[data-theme='dark'] .MuiSelect-select,\n[data-theme='dark'] .MuiSelect-icon,\n[data-theme='dark'] .MuiSvgIcon-root,\n[data-theme='dark'] .MuiInputLabel-root,\n[data-theme='dark'] .MuiFormHelperText-root {\n  color: var(--text-primary);\n}\n\n[data-theme='dark'] .MuiOutlinedInput-notchedOutline {\n  border-color: var(--border-color);\n}\n\n/* Standard (underline) variant inputs */\n[data-theme='dark'] .MuiInput-underline:before {\n  border-bottom-color: var(--border-color);\n}\n\n[data-theme='dark'] .MuiInput-underline:hover:not(.Mui-disabled):before {\n  border-bottom-color: var(--text-secondary);\n}\n\n[data-theme='dark'] .MuiInput-underline:after {\n  border-bottom-color: var(--accent-color);\n}\n\n/* Checkboxes: make outline/check visible in dark mode */\n[data-theme='dark'] .MuiCheckbox-root {\n  color: var(--text-primary);\n}\n\n[data-theme='dark'] .MuiCheckbox-root.Mui-checked {\n  color: var(--accent-color);\n}\n\n[data-theme='dark'] .MuiPaper-root.MuiMenu-paper,\n[data-theme='dark'] .MuiPaper-root.MuiPopover-paper {\n  background-color: var(--bg-secondary);\n  color: var(--text-primary);\n}\n\n[data-theme='dark'] .MuiPaper-root.MuiMenu-paper .MuiMenuItem-root,\n[data-theme='dark'] .MuiPaper-root.MuiPopover-paper .MuiMenuItem-root {\n  color: var(--text-primary);\n}\n\n/* Common component styles */\n.card {\n  background-color: var(--card-bg);\n  border: 1px solid var(--border-color);\n  border-radius: var(--border-radius);\n  box-shadow: var(--box-shadow);\n  transition: all 0.3s ease;\n}\n\n.card:hover {\n  box-shadow: 0 4px 16px var(--shadow-color);\n}\n\n.input-field {\n  background-color: var(--input-bg);\n  border: 1px solid var(--border-color);\n  border-radius: var(--border-radius);\n  color: var(--text-primary);\n  transition: all 0.3s ease;\n}\n\n.input-field:focus {\n  border-color: var(--accent-color);\n  box-shadow: 0 0 0 2px rgba(97, 218, 251, 0.2);\n}\n\n.button {\n  background-color: var(--accent-color);\n  color: var(--text-primary);\n  border: none;\n  border-radius: var(--border-radius);\n  padding: 8px 16px;\n  cursor: pointer;\n  transition: all 0.3s ease;\n}\n\n.button:hover {\n  background-color: var(--button-hover);\n  transform: translateY(-1px);\n}\n\n/* Status colors */\n.status-success {\n  color: var(--success-color);\n}\n\n.status-warning {\n  color: var(--warning-color);\n}\n\n.status-error {\n  color: var(--error-color);\n}\n\n.status-info {\n  color: var(--info-color);\n}\n\n/* Smooth transitions for all theme changes */\n* {\n  transition:\n    background-color 0.3s ease,\n    color 0.3s ease,\n    border-color 0.3s ease,\n    box-shadow 0.3s ease;\n}\n\n/* Scrollbar theming */\n::-webkit-scrollbar {\n  width: 8px;\n}\n\n::-webkit-scrollbar-track {\n  background: var(--bg-secondary);\n}\n\n::-webkit-scrollbar-thumb {\n  background: var(--border-color);\n  border-radius: 4px;\n}\n\n::-webkit-scrollbar-thumb:hover {\n  background: var(--text-secondary);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
